import { bindable, inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@inject(Router)
export class NavLink {
    @bindable route;
    @bindable title;
    @bindable icon;

    constructor(router) {
        this.router = router;
    }
}